import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { Page } from "@/components/Page";

export function AdminReturnPolicy() {
  const [f, setF] = useState({ title: "", summary: "", sections: [], contact: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/return-policy")
    .then(r => setF({ title: r.data.title || "", summary: r.data.summary || "", sections: r.data.sections || [], contact: r.data.contact || "" }))
    .catch(err => toast.error(formatError(err)));
  useEffect(() => { load(); }, []);

  const setSection = (i, k, v) => setF(x => ({ ...x, sections: x.sections.map((s, j) => j === i ? { ...s, [k]: v } : s) }));
  const addSection = () => setF(x => ({ ...x, sections: [...x.sections, { heading: "", body: "" }] }));
  const removeSection = (i) => setF(x => ({ ...x, sections: x.sections.filter((_, j) => j !== i) }));

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.put("/admin/return-policy", f); toast.success("Return policy updated"); }
    catch (err) { toast.error(formatError(err)); } finally { setBusy(false); }
  };

  return (
    <Page title="Return policy" subtitle="Displayed to buyers on the public /return-policy page and included in order emails.">
      <form className="form-section" onSubmit={save}>
        <label>Title<input required value={f.title} onChange={e => setF({ ...f, title: e.target.value })} data-testid="rp-admin-title" /></label>
        <label>Summary (shown as intro)
          <textarea rows={3} required value={f.summary} onChange={e => setF({ ...f, summary: e.target.value })} data-testid="rp-admin-summary" />
        </label>
        <div className="admin-table" data-testid="rp-admin-sections">
          {f.sections.map((s, i) => (
            <div className="form-section" key={i} style={{ marginTop: 12 }} data-testid={`rp-admin-section-${i}`}>
              <div className="field-grid">
                <label>Heading<input value={s.heading} onChange={e => setSection(i, "heading", e.target.value)} data-testid={`rp-section-heading-${i}`} /></label>
                <label style={{ alignSelf: "end" }}>
                  <button type="button" className="danger-btn" onClick={() => removeSection(i)} data-testid={`rp-section-delete-${i}`}><Trash2 size={13} /> Remove</button>
                </label>
              </div>
              <label>Body<textarea rows={3} value={s.body} onChange={e => setSection(i, "body", e.target.value)} data-testid={`rp-section-body-${i}`} /></label>
            </div>
          ))}
        </div>
        <div className="form-actions">
          <button type="button" className="secondary-btn" onClick={addSection} data-testid="rp-admin-add-section"><Plus size={13} /> Add section</button>
        </div>
        <label>Support contact (email)<input type="email" value={f.contact} onChange={e => setF({ ...f, contact: e.target.value })} data-testid="rp-admin-contact" placeholder="support@truevision.example" /></label>
        <div className="form-actions">
          <span className="muted">Public /return-policy page updates instantly.</span>
          <button className="primary-btn" disabled={busy} data-testid="rp-admin-save">{busy ? "Saving…" : <>Save policy <Save size={14} /></>}</button>
        </div>
      </form>
    </Page>
  );
}
